import { colors } from '../ui/styles'

interface NavQuickJumpProps {
  readonly query: string
  readonly onChange: (query: string) => void
}

// Filter box at the top of the sidebar: typing narrows the nav to
// matching entries (including settings tabs on edge deployments),
// bypassing section collapse. Esc clears.
export function NavQuickJump({ query, onChange }: NavQuickJumpProps): JSX.Element {
  return (
    <div style={{ padding: '4px 15px 8px' }}>
      <input
        type="search"
        value={query}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.preventDefault()
            onChange('')
          }
        }}
        placeholder="Jump to..."
        aria-label="Jump to a page"
        data-testid="nav-quick-jump"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '6px 10px',
          fontSize: '0.8125rem',
          color: colors.text,
          background: colors.bgMuted,
          border: `1px solid ${colors.sidebarBorder}`,
          borderRadius: '3px',
          outlineColor: colors.accent,
        }}
      />
    </div>
  )
}
